function normalizeInvoiceStatus(status) {
  return String(status ?? "").trim().toLowerCase();
}

export function resolveInvoicePdfWatermark(status) {
  const normalized = normalizeInvoiceStatus(status);

  if (normalized === "draft") {
    return {
      text: "DRAFT",
      color: "#ef4444",
      opacity: 0.2,
      bold: true,
      angle: -45,
      fontSize: 84,
    };
  }

  if (normalized === "pending approval") {
    return {
      text: "FINAL",
      color: "#16a34a",
      opacity: 0.2,
      bold: true,
      angle: -45,
      fontSize: 84,
    };
  }

  return null;
}
